import { j as e } from "../../jsx-runtime-C5mzlN2N.js";
import "../../styles-DaQVIHg4.js";
import { T as s } from "../../Typography-CGn3dGWy.js";
import { B as r } from "../../Button-DkQlhrIH.js";
import { I as d } from "../../CheckIcon-XCAywhAi.js";
import "react";
import "../Icon/countryVariants.es.js";
import a from "styled-components";
import "../Theme/themes.es.js";
import "../../palettes-Bw24w7AF.js";
import { getSpacings as l } from "../Theme/utils.es.js";
import "../../CssBaseline-Bp4jdUgb.js";
import "../../ErrorFeedbackContainer-B0KLd565.js";
import { P as x, S as h } from "../../SomethingWentWrongFeedback-DZKC_tDY.js";
const p = a.div`
  width: 100%;
  display: flex;
  align-self: center;
  align-items: center;
  height: 100vh;
`, f = a.div`
  flex: 1 0 0;
  display: flex;
  align-items: center;
  align-self: stretch;
  flex-direction: column;
  justify-content: center;
  gap: ${l("6xl")} ${l("6xl")};
`, j = a.div`
  display: flex;
  align-items: flex-start;
  gap: ${l("lg")};
`, c = (o) => {
  const {
    className: i,
    actions: t,
    feedback: n
  } = o;
  return /* @__PURE__ */ e.jsx(p, { className: i, children: /* @__PURE__ */ e.jsxs(f, { children: [
    n,
    /* @__PURE__ */ e.jsx(j, { children: t })
  ] }) });
}, B = (o) => {
  const {
    className: i,
    message: t = "The page you are looking for doesn't exist or has been moved.",
    title: n,
    onGoBackClick: m,
    onGotoLoginClick: g
  } = o;
  return /* @__PURE__ */ e.jsx(
    c,
    {
      className: i,
      feedback: /* @__PURE__ */ e.jsx(
        x,
        {
          title: n,
          message: t
        }
      ),
      actions: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          r,
          {
            size: "2xl",
            startAdornment: /* @__PURE__ */ e.jsx(d, { variant: "arrow-left" }),
            variant: "outlined",
            color: "gray",
            onClick: m,
            children: /* @__PURE__ */ e.jsx(s, { size: "lg", weight: "semibold", color: "secondary", children: "Go back" })
          }
        ),
        /* @__PURE__ */ e.jsx(
          r,
          {
            size: "2xl",
            onClick: g,
            children: /* @__PURE__ */ e.jsx(s, { size: "lg", weight: "semibold", color: "white", children: "Go to log in" })
          }
        )
      ] })
    }
  );
}, R = (o) => {
  const {
    className: i,
    onRefreshClick: t
  } = o;
  return /* @__PURE__ */ e.jsx(
    c,
    {
      className: i,
      feedback: /* @__PURE__ */ e.jsx(
        h,
        {
          message: "We are working on fixing the problem. Please try again."
        }
      ),
      actions: /* @__PURE__ */ e.jsx(
        r,
        {
          size: "2xl",
          onClick: t,
          children: /* @__PURE__ */ e.jsx(s, { size: "lg", weight: "semibold", color: "white", children: "Refresh page" })
        }
      )
    }
  );
};
export {
  B as PageNotFound,
  R as SomethingWentWrong
};
